import { LazyLoadVirtualList } from '@modules/common/components/LazyLoadVirtualList';
import { useNotificationContext } from '@modules/common/components/Notification/NotificationContext';
import { Box } from '@mui/material';
import { useState } from 'react';
import { CollectionListItem } from '../CollectionListItem';
import { OpenInCollectionLink } from '../OpenInCollectionLink';
import { SAMPLE_COLLECTIONS } from '../utils/sampleCollections';

interface CollectionListProps {
  searchTerm: string;
}

export const CollectionList = ({ searchTerm }: CollectionListProps) => {
  const [selectedCollectionIDs, setSelectedCollectionIDs] = useState<
    Set<string>
  >(new Set());

  const { showSuccessNotification } = useNotificationContext();

  const addToCollection = (id: string, name: string) => {
    const newSet = new Set(selectedCollectionIDs).add(id);
    setSelectedCollectionIDs(newSet);
    showSuccessNotification({
      contentComponent: `Feedback record added to "${name}"`,
      props: {
        severity: 'success',
        timeout: 15000,
        isClosable: true,
        action: <OpenInCollectionLink collectionID={id} />,
      },
    });
  };

  const removeFromCollection = (
    event: React.MouseEvent<HTMLButtonElement>,
    id: string,
    name: string,
  ) => {
    event.stopPropagation();
    const newSet = new Set(selectedCollectionIDs);
    newSet.delete(id);
    setSelectedCollectionIDs(newSet);
    showSuccessNotification({
      contentComponent: `Feedback record removed from "${name}"`,
      props: {
        severity: 'success',
        timeout: 15000,
        isClosable: true,
        action: <OpenInCollectionLink collectionID={id} />,
      },
    });
  };

  const renderCollectionListItem = ({ id, name }: any) => {
    return (
      <CollectionListItem
        key={id}
        id={id}
        name={name}
        addToCollection={addToCollection}
        removeFromCollection={removeFromCollection}
        isFeedbackPartOfCollection={selectedCollectionIDs.has(id)}
      />
    );
  };

  return (
    <Box height={230} overflow="auto">
      <LazyLoadVirtualList
        data={SAMPLE_COLLECTIONS.filter((collection) =>
          collection.name.toLowerCase().includes(searchTerm.toLowerCase()),
        )}
        loadMoreItems={() => {}}
        listHeight={230}
        defaultListItemHeight={43}
        renderRowComponent={renderCollectionListItem}
        hasNextPage={false}
      />
    </Box>
  );
};
